import cn from 'classnames';

import { Email } from '@zooplus/icons';
import { FlatBox, P1 } from '@zooplus/ui-components';

import styles from './customer-information.module.scss';

interface ReadOnlyEmailSectionProps {
  email?: string;
}

const ReadOnlyEmailSection = ({ email }: ReadOnlyEmailSectionProps) => (
  <FlatBox
    rounded
    variant="white"
    className={cn(styles.readOnlyEmailBox, 'pp-ml-xl pp-pl-2xs')}
    data-testid="read-only-email-box">
    <Email width={20} height={20} />
    <P1>{email}</P1>
  </FlatBox>
);

export default ReadOnlyEmailSection;
